export default function Features() {
  const features = [
    {
      title: "Fun Gameplay",
      description: "Bounce balloons, unlock levels, chase high scores.",
      icon: "🎮",
    },
    {
      title: "Family‑Friendly Design",
      description: "Safe content, no surprises.",
      icon: "👨‍👩‍👧‍👦",
    },
    {
      title: "Rewards & Milestones",
      description: "Earn stars, unlock bonuses.",
      icon: "⭐",
    },
    {
      title: "Multilingual Support",
      description: "English, Hindi, Spanish, Portuguese, Chinese.",
      icon: "🌍",
    },
    {
      title: "Lightweight & Fast",
      description: "Smooth play on most Android devices.",
      icon: "⚡",
    },
  ];

  return (
    <section className="max-w-6xl mx-auto px-6 py-16">
      <h2 className="text-4xl font-bold text-blue-600 mb-10 text-center">
        Why You’ll Love Popalooza
      </h2>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition"
          >
            <div className="text-4xl mb-4">{feature.icon}</div>
            <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
            <p className="text-gray-700 leading-relaxed">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
